var moduleMap = {
	"./stores/organisation": () => {
		return Promise.all(/* __federation_expose_stores__organisation */[__webpack_require__.e(1083), __webpack_require__.e(1793), __webpack_require__.e(63), __webpack_require__.e(3945), __webpack_require__.e(3284), __webpack_require__.e(7994)]).then(() => (() => ((__webpack_require__(7646)))));
	},
	"./stores/user": () => {
		return Promise.all(/* __federation_expose_stores__user */[__webpack_require__.e(1083), __webpack_require__.e(1793), __webpack_require__.e(63), __webpack_require__.e(3945), __webpack_require__.e(7805)]).then(() => (() => ((__webpack_require__(2347)))));
	},
	"./stores/promptPrefill": () => {
		return Promise.all(/* __federation_expose_stores__promptPrefill */[__webpack_require__.e(1793), __webpack_require__.e(3945), __webpack_require__.e(9398)]).then(() => (() => ((__webpack_require__(5812)))));
	},
	"./stores/projectsList": () => {
		return Promise.all(/* __federation_expose_stores__projectsList */[__webpack_require__.e(1793), __webpack_require__.e(3945), __webpack_require__.e(5958)]).then(() => (() => ((__webpack_require__(4102)))));
	},
	"./api/organisation": () => {
		return Promise.all(/* __federation_expose_api__organisation */[__webpack_require__.e(1083), __webpack_require__.e(63), __webpack_require__.e(3284)]).then(() => (() => ((__webpack_require__(7925)))));
	},
	"./api/user": () => {
		return Promise.all(/* __federation_expose_api__user */[__webpack_require__.e(1083), __webpack_require__.e(63), __webpack_require__.e(9723)]).then(() => (() => ((__webpack_require__(2600)))));
	},
	"./api/uploader": () => {
		return Promise.all(/* __federation_expose_api__uploader */[__webpack_require__.e(1083), __webpack_require__.e(63), __webpack_require__.e(936)]).then(() => (() => ((__webpack_require__(6961)))));
	},
	"./api/mediafile": () => {
		return Promise.all(/* __federation_expose_api__mediafile */[__webpack_require__.e(1083), __webpack_require__.e(63), __webpack_require__.e(9088)]).then(() => (() => ((__webpack_require__(3593)))));
	},
	"./api/creative": () => {
		return Promise.all(/* __federation_expose_api__creative */[__webpack_require__.e(1083), __webpack_require__.e(63), __webpack_require__.e(2053)]).then(() => (() => ((__webpack_require__(7238)))));
	},
	"./api/statistic": () => {
		return Promise.all(/* __federation_expose_api__statistic */[__webpack_require__.e(1083), __webpack_require__.e(63), __webpack_require__.e(8840)]).then(() => (() => ((__webpack_require__(6513)))));
	},
	"./ui/avatar": () => {
		return Promise.all(/* __federation_expose_ui__avatar */[__webpack_require__.e(4492), __webpack_require__.e(7817), __webpack_require__.e(6707)]).then(() => (() => ((__webpack_require__(3225)))));
	},
	"./ui/button": () => {
		return Promise.all(/* __federation_expose_ui__button */[__webpack_require__.e(4492), __webpack_require__.e(7817), __webpack_require__.e(2223), __webpack_require__.e(436)]).then(() => (() => ((__webpack_require__(2102)))));
	},
	"./ui/card": () => {
		return Promise.all(/* __federation_expose_ui__card */[__webpack_require__.e(4492), __webpack_require__.e(5298)]).then(() => (() => ((__webpack_require__(6420)))));
	},
	"./ui/dialog": () => {
		return Promise.all(/* __federation_expose_ui__dialog */[__webpack_require__.e(4492), __webpack_require__.e(7817), __webpack_require__.e(4738), __webpack_require__.e(3864)]).then(() => (() => ((__webpack_require__(7922)))));
	},
	"./ui/input": () => {
		return Promise.all(/* __federation_expose_ui__input */[__webpack_require__.e(4492), __webpack_require__.e(6180)]).then(() => (() => ((__webpack_require__(3672)))));
	},
	"./ui/label": () => {
		return Promise.all(/* __federation_expose_ui__label */[__webpack_require__.e(4492), __webpack_require__.e(7817), __webpack_require__.e(5154)]).then(() => (() => ((__webpack_require__(2854)))));
	},
	"./ui/pagination": () => {
		return Promise.all(/* __federation_expose_ui__pagination */[__webpack_require__.e(4492), __webpack_require__.e(7817), __webpack_require__.e(4738), __webpack_require__.e(2223), __webpack_require__.e(1776)]).then(() => (() => ((__webpack_require__(9471)))));
	},
	"./ui/select": () => {
		return Promise.all(/* __federation_expose_ui__select */[__webpack_require__.e(4492), __webpack_require__.e(6413), __webpack_require__.e(7817), __webpack_require__.e(4738), __webpack_require__.e(8448)]).then(() => (() => ((__webpack_require__(8718)))));
	},
	"./ui/spinner": () => {
		return Promise.all(/* __federation_expose_ui__spinner */[__webpack_require__.e(4492), __webpack_require__.e(4738), __webpack_require__.e(3943)]).then(() => (() => ((__webpack_require__(8211)))));
	},
	"./ui/switch": () => {
		return Promise.all(/* __federation_expose_ui__switch */[__webpack_require__.e(4492), __webpack_require__.e(7817), __webpack_require__.e(1804)]).then(() => (() => ((__webpack_require__(3390)))));
	},
	"./ui/tooltip": () => {
		return Promise.all(/* __federation_expose_ui__tooltip */[__webpack_require__.e(4492), __webpack_require__.e(7817), __webpack_require__.e(7737)]).then(() => (() => ((__webpack_require__(9681)))));
	},
	"./ui/cascader": () => {
		return Promise.all(/* __federation_expose_ui__cascader */[__webpack_require__.e(6413), __webpack_require__.e(4738), __webpack_require__.e(9811), __webpack_require__.e(3624)]).then(() => (() => ((__webpack_require__(9811)))));
	},
	"./components/ErrorBoundary": () => {
		return Promise.all(/* __federation_expose_components__ErrorBoundary */[__webpack_require__.e(4492), __webpack_require__.e(6413), __webpack_require__.e(2223), __webpack_require__.e(5798)]).then(() => (() => ((__webpack_require__(9819)))));
	},
	"./components/StateView": () => {
		return Promise.all(/* __federation_expose_components__StateView */[__webpack_require__.e(4492), __webpack_require__.e(7817), __webpack_require__.e(4738), __webpack_require__.e(2223), __webpack_require__.e(3566)]).then(() => (() => ((__webpack_require__(5983)))));
	},
	"./components/ConfirmDialog": () => {
		return Promise.all(/* __federation_expose_components__ConfirmDialog */[__webpack_require__.e(4492), __webpack_require__.e(7817), __webpack_require__.e(4738), __webpack_require__.e(2223), __webpack_require__.e(1366)]).then(() => (() => ((__webpack_require__(6807)))));
	},
	"./components/PlaceholderPanel": () => {
		return Promise.all(/* __federation_expose_components__PlaceholderPanel */[__webpack_require__.e(4492), __webpack_require__.e(4738), __webpack_require__.e(2223), __webpack_require__.e(8677)]).then(() => (() => ((__webpack_require__(7624)))));
	},
	"./components/PermissionGate": () => {
		return Promise.all(/* __federation_expose_components__PermissionGate */[__webpack_require__.e(4492), __webpack_require__.e(6413), __webpack_require__.e(7817), __webpack_require__.e(5486)]).then(() => (() => ((__webpack_require__(1895)))));
	},
	"./components/NoAccessState": () => {
		return Promise.all(/* __federation_expose_components__NoAccessState */[__webpack_require__.e(4492), __webpack_require__.e(7817), __webpack_require__.e(4738), __webpack_require__.e(2223), __webpack_require__.e(1608)]).then(() => (() => ((__webpack_require__(8825)))));
	},
	"./components/ProjectsListSkeleton": () => {
		return __webpack_require__.e(/* __federation_expose_components__ProjectsListSkeleton */ 1861).then(() => (() => ((__webpack_require__(4882)))));
	},
	"./components/ProjectImagesSkeleton": () => {
		return __webpack_require__.e(/* __federation_expose_components__ProjectImagesSkeleton */ 646).then(() => (() => ((__webpack_require__(5906)))));
	},
	"./components/ProjectCreativesSkeleton": () => {
		return __webpack_require__.e(/* __federation_expose_components__ProjectCreativesSkeleton */ 6172).then(() => (() => ((__webpack_require__(6464)))));
	},
	"./components/CreateProjectDialog": () => {
		return Promise.all(/* __federation_expose_components__CreateProjectDialog */[__webpack_require__.e(1083), __webpack_require__.e(4492), __webpack_require__.e(6413), __webpack_require__.e(63), __webpack_require__.e(7817), __webpack_require__.e(4738), __webpack_require__.e(3284), __webpack_require__.e(6470), __webpack_require__.e(5089)]).then(() => (() => ((__webpack_require__(861)))));
	},
	"./components/CreateOrganisationDialog": () => {
		return Promise.all(/* __federation_expose_components__CreateOrganisationDialog */[__webpack_require__.e(1083), __webpack_require__.e(1793), __webpack_require__.e(4492), __webpack_require__.e(6413), __webpack_require__.e(63), __webpack_require__.e(7817), __webpack_require__.e(4738), __webpack_require__.e(3945), __webpack_require__.e(3284), __webpack_require__.e(9836)]).then(() => (() => ((__webpack_require__(702)))));
	},
	"./components/DateRangeControls": () => {
		return Promise.all(/* __federation_expose_components__DateRangeControls */[__webpack_require__.e(6413), __webpack_require__.e(3079)]).then(() => (() => ((__webpack_require__(4297)))));
	},
	"./components/ReportChart": () => {
		return Promise.all(/* __federation_expose_components__ReportChart */[__webpack_require__.e(8366), __webpack_require__.e(6413), __webpack_require__.e(4738), __webpack_require__.e(9811), __webpack_require__.e(792)]).then(() => (() => ((__webpack_require__(4309)))));
	},
	"./components/ReportTable": () => {
		return Promise.all(/* __federation_expose_components__ReportTable */[__webpack_require__.e(6413), __webpack_require__.e(8393), __webpack_require__.e(2364)]).then(() => (() => ((__webpack_require__(2244)))));
	},
	"./components/MetricCascader": () => {
		return Promise.all(/* __federation_expose_components__MetricCascader */[__webpack_require__.e(6413), __webpack_require__.e(4738), __webpack_require__.e(9811), __webpack_require__.e(5746)]).then(() => (() => ((__webpack_require__(8789)))));
	},
	"./components/Disclosure": () => {
		return Promise.all(/* __federation_expose_components__Disclosure */[__webpack_require__.e(6413), __webpack_require__.e(85)]).then(() => (() => ((__webpack_require__(1560)))));
	},
	"./components/InviteUserDialog": () => {
		return Promise.all(/* __federation_expose_components__InviteUserDialog */[__webpack_require__.e(1083), __webpack_require__.e(4492), __webpack_require__.e(6413), __webpack_require__.e(63), __webpack_require__.e(7817), __webpack_require__.e(4738), __webpack_require__.e(3284), __webpack_require__.e(8393), __webpack_require__.e(1368)]).then(() => (() => ((__webpack_require__(8364)))));
	},
	"./components/CreativePreview": () => {
		return Promise.all(/* __federation_expose_components__CreativePreview */[__webpack_require__.e(4492), __webpack_require__.e(6413), __webpack_require__.e(7367)]).then(() => (() => ((__webpack_require__(2210)))));
	},
	"./components/GenerationField": () => {
		return Promise.all(/* __federation_expose_components__GenerationField */[__webpack_require__.e(6413), __webpack_require__.e(7944)]).then(() => (() => ((__webpack_require__(103)))));
	},
	"./hooks/useActiveOrganisation": () => {
		return Promise.all(/* __federation_expose_hooks__useActiveOrganisation */[__webpack_require__.e(1083), __webpack_require__.e(1793), __webpack_require__.e(63), __webpack_require__.e(3945), __webpack_require__.e(3284), __webpack_require__.e(943)]).then(() => (() => ((__webpack_require__(6156)))));
	},
	"./hooks/useDebouncedCallback": () => {
		return Promise.all(/* __federation_expose_hooks__useDebouncedCallback */[__webpack_require__.e(6413), __webpack_require__.e(1175)]).then(() => (() => ((__webpack_require__(6500)))));
	},
	"./hooks/useOverlayDismiss": () => {
		return Promise.all(/* __federation_expose_hooks__useOverlayDismiss */[__webpack_require__.e(6413), __webpack_require__.e(7603)]).then(() => (() => ((__webpack_require__(3640)))));
	},
	"./hooks/useAnalyticsParams": () => {
		return Promise.all(/* __federation_expose_hooks__useAnalyticsParams */[__webpack_require__.e(6413), __webpack_require__.e(6470), __webpack_require__.e(3883)]).then(() => (() => ((__webpack_require__(5101)))));
	},
	"./hooks/useReportChartData": () => {
		return Promise.all(/* __federation_expose_hooks__useReportChartData */[__webpack_require__.e(1083), __webpack_require__.e(6413), __webpack_require__.e(63), __webpack_require__.e(3367)]).then(() => (() => ((__webpack_require__(2877)))));
	},
	"./hooks/usePermissions": () => {
		return Promise.all(/* __federation_expose_hooks__usePermissions */[__webpack_require__.e(1083), __webpack_require__.e(1793), __webpack_require__.e(6413), __webpack_require__.e(63), __webpack_require__.e(3945), __webpack_require__.e(7937)]).then(() => (() => ((__webpack_require__(3538)))));
	},
	"./hooks/useProjectRole": () => {
		return Promise.all(/* __federation_expose_hooks__useProjectRole */[__webpack_require__.e(1083), __webpack_require__.e(1793), __webpack_require__.e(6413), __webpack_require__.e(63), __webpack_require__.e(3945), __webpack_require__.e(3284), __webpack_require__.e(8055), __webpack_require__.e(5850)]).then(() => (() => ((__webpack_require__(4951)))));
	},
	"./hooks/useMediaFiles": () => {
		return Promise.all(/* __federation_expose_hooks__useMediaFiles */[__webpack_require__.e(1083), __webpack_require__.e(6413), __webpack_require__.e(63), __webpack_require__.e(9088), __webpack_require__.e(8055), __webpack_require__.e(6854)]).then(() => (() => ((__webpack_require__(7518)))));
	},
	"./lib/utils": () => {
		return Promise.all(/* __federation_expose_lib__utils */[__webpack_require__.e(4492), __webpack_require__.e(2930)]).then(() => (() => ((__webpack_require__(9973)))));
	},
	"./lib/toast": () => {
		return Promise.all(/* __federation_expose_lib__toast */[__webpack_require__.e(63), __webpack_require__.e(7144)]).then(() => (() => ((__webpack_require__(8715)))));
	},
	"./lib/clipboard": () => {
		return Promise.all(/* __federation_expose_lib__clipboard */[__webpack_require__.e(63), __webpack_require__.e(9659)]).then(() => (() => ((__webpack_require__(8170)))));
	},
	"./lib/creativeSizes": () => {
		return __webpack_require__.e(/* __federation_expose_lib__creativeSizes */ 9890).then(() => (() => ((__webpack_require__(5265)))));
	},
	"./lib/errorExtractor": () => {
		return __webpack_require__.e(/* __federation_expose_lib__errorExtractor */ 8909).then(() => (() => ((__webpack_require__(8836)))));
	},
	"./lib/permissions": () => {
		return __webpack_require__.e(/* __federation_expose_lib__permissions */ 6097).then(() => (() => ((__webpack_require__(5860)))));
	},
	"./lib/accessError": () => {
		return __webpack_require__.e(/* __federation_expose_lib__accessError */ 5249).then(() => (() => ((__webpack_require__(1084)))));
	},
	"./lib/localStorageHelper": () => {
		return __webpack_require__.e(/* __federation_expose_lib__localStorageHelper */ 8467).then(() => (() => ((__webpack_require__(578)))));
	},
	"./lib/activity": () => {
		return Promise.all(/* __federation_expose_lib__activity */[__webpack_require__.e(1083), __webpack_require__.e(63), __webpack_require__.e(9088), __webpack_require__.e(6956)]).then(() => (() => ((__webpack_require__(7252)))));
	},
	"./lib/organisationOptions": () => {
		return __webpack_require__.e(/* __federation_expose_lib__organisationOptions */ 6001).then(() => (() => ((__webpack_require__(7768)))));
	},
	"./lib/analytics/datePresets": () => {
		return __webpack_require__.e(/* __federation_expose_lib__analytics__datePresets */ 9005).then(() => (() => ((__webpack_require__(8459)))));
	},
	"./lib/analytics/reportCatalog": () => {
		return __webpack_require__.e(/* __federation_expose_lib__analytics__reportCatalog */ 6070).then(() => (() => ((__webpack_require__(3502)))));
	},
	"./lib/analytics/reportVm": () => {
		return __webpack_require__.e(/* __federation_expose_lib__analytics__reportVm */ 8038).then(() => (() => ((__webpack_require__(4924)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};
// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});